import { v4 as uuidv4 } from 'uuid';

export function Share(props = {}, childrenComponents = []) {
	return {
		componentName: 'Share',
		componentId: uuidv4(),
		props: Object.assign(
			{
				blockClass: 'sharexx',
				shareLabelClass: 'labelSharexx',
				buttonsContainerClass: 'buttonSharexx',
				options: {
					size: 40,
				},
				social: {
					Facebook: true,
					Twitter: true,
					WhatsApp: true,
					Pinterest: true,
				},
			},
			props,
		),
		childrenComponents,
	};
}
